import apiCore from "services/apiCore";
import _ from "lodash";

const BASE_URI = "/routing/queues/";
const BASE_WRAPUP_URI = "/routing/wrapupcodes";

const buildWrapupCodesUri = function (queueId) {
    return BASE_URI + queueId + "/wrapupcodes";
};

const wrapUpCodeService = {
    getWrapupCodes: function (options) {
        return apiCore.v2.get(BASE_WRAPUP_URI, options);
    },
    getWrapupCodesForQueue: function (options, queueId) {
        options = _.assign({ pageSize: 100, pageNumber: 1 }, options);
        return apiCore.v2.get(buildWrapupCodesUri(queueId), options);
    },
    getWrapupCodeById: function (id) {
        return apiCore.v2.get(BASE_WRAPUP_URI + "/" + id);
    },
};

export default wrapUpCodeService;
